import React, { Component } from "react";
class Gallery extends Component {
  render() {
    return (
      <div className="container">
        <h1>Gallery</h1>
        <p>TEsting</p>
      </div>
    );
  }
}

export default Gallery;
